export function delay(n) {
  return new Promise(res => setTimeout(res, n));
}

export function callWithDelay(n, ...fns) {
  return Promise.all([
    ...fns,
    delay(n),
  ])
    .then(response => response.slice(0, response.length - 1));
}

export function flowGenerators(flow) {
  return {
    updateOrderGenerator: null,
    next(...params) {
      const { value } = this.updateOrderGenerator.next(...params);
      return value;
    },
    run(...params) {
      this.updateOrderGenerator = flow(...params);
      const { value } = this.updateOrderGenerator.next();
      return value;
    },
  };
}
